import React from 'react';
import { ButtonSmall } from './../../app/common/sharedComponents/buttons/ButtonSmall';
import { ButtonRowContainer } from './SimulateStandard.styled';

const SimulateButton = (props) => {
  const {
    produceSelected,
    produceSelectedValue,
    selected,
    standards,
    isMissedStandard,
    setSelectedBtn,
    selectedBtn,
  } = props;
  return (
    <ButtonRowContainer>
      <ButtonSmall
        inverted={true}
        outlined={true}
        rounded={true}
        backgroundColor={selectedBtn === 1 ? 'verdigrisDark' : 'battleShipGray'}
        title={isMissedStandard ? 'Top 5' : '5 Standards'}
        onClick={() => {
          setSelectedBtn(1);
          produceSelected((draft) => {
            [0, 1, 2, 3, 4].map((o) => (draft[o] = true));
            [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19].map(
              (o) => (draft[o] = false)
            );
          });
          produceSelectedValue((d) => {
            if (!selected[0]) {
              [0, 1, 2, 3, 4].map((o) => (d[o] = standards[o].total));
            } else {
              [0, 1, 2, 3, 4].map(
                (o) => (d[o] = standards[o].total - standards[o].missedCount)
              );
            }
          });
        }}
      />
      <ButtonSmall
        inverted={true}
        outlined={true}
        rounded={true}
        backgroundColor={selectedBtn === 2 ? 'verdigrisDark' : 'battleShipGray'}
        title={isMissedStandard ? 'Top 10' : '10 Standards'}
        onClick={() => {
          setSelectedBtn(2);
          produceSelected((draft) => {
            [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((o) => (draft[o] = true));
            [10, 11, 12, 13, 14, 15, 16, 17, 18, 19].map(
              (o) => (draft[o] = false)
            );
          });
          produceSelectedValue((d) => {
            if (!selected[5]) {
              [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(
                (o) => (d[o] = standards[o].total)
              );
            } else {
              [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(
                (o) => (d[o] = standards[o].total - standards[o].missedCount)
              );
            }
          });
        }}
      />
      <ButtonSmall
        inverted={true}
        outlined={true}
        rounded={true}
        backgroundColor={selectedBtn === 3 ? 'verdigrisDark' : 'battleShipGray'}
        title={isMissedStandard ? 'Top 20' : '20 Standards'}
        onClick={() => {
          setSelectedBtn(3);
          produceSelected((draft) => {
            [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19,
            ].map((o) => (draft[o] = true));
          });
          produceSelectedValue((d) => {
            if (!selected[10]) {
              [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                18, 19,
              ].map((o) => (d[o] = standards[o].total));
            } else {
              [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                18, 19,
              ].map(
                (o) => (d[o] = standards[o].total - standards[o].missedCount)
              );
            }
          });
        }}
      />
    </ButtonRowContainer>
  );
};

export default SimulateButton;
